import { Injectable } from '@angular/core';
import { AssetGroup } from '@app/shared/models/asset-group.model';
import { DynamicFormFieldOption } from '@app/shared/models/dynamic-form.model';

@Injectable()
export class AssetGroupsHelperService {
    getTreeViewOptions(hierarchy: AssetGroup[]): DynamicFormFieldOption[] {
        const flatList = this.getFlatList(hierarchy);

        const adaptOption = (assetGroup: AssetGroup): DynamicFormFieldOption => {
            return {
                id: assetGroup.id,
                label: assetGroup.name,
                description: this.getGroupName(flatList, assetGroup.id),
                icon: assetGroup.icon,
                children: assetGroup.children.map((child) => adaptOption(child)),
                object: assetGroup,
            };
        };

        return hierarchy.map((assetGroup) => adaptOption(assetGroup));
    }

    getFlatList(assetGroups: AssetGroup[]): AssetGroup[] {
        return assetGroups.flatMap((current: AssetGroup) => [
            current,
            ...this.getFlatList(current.children),
        ]);
    }

    getGroupName(assetGroups: AssetGroup[], assetGroupId: number) {
        const assetGroup = assetGroups.find((group) => group.id === assetGroupId);
        return `${assetGroup.name} ${this.getHierarchyGroupNames(assetGroups, assetGroup)}`.trim();
    }

    getHierarchyGroupNames(assetGroups: AssetGroup[], assetGroup: AssetGroup): string {
        const parents: string[] = [];

        const fn = (array: string[], ag: AssetGroup) => {
            if (ag.parentId) {
                const parent = assetGroups.find((group) => group.id === ag.parentId);
                array.unshift(parent.name.trim());
                fn(array, parent);
            }

            return array;
        };

        fn(parents, assetGroup);
        return parents.length ? `[ ${parents.join(' - ')} ]` : '';
    }
}
